
import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Table
} from 'reactstrap';


import Cargando from './../components/Cargando';
import CargandoTabla from './../components/CargandoTabla';
import Anuncio from './../api/Anuncio';

import Ciclo from './../api/Ciclo'; 

const ciclo = new Ciclo();

const anuncio = new Anuncio();

class VerAnuncios extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            cargando:false,
            usuario: this.props.user.rut,
            cargandoTabla:false
        }
   
    }


    listadoAnuncios = async() => {
        this.setState({cargandoTabla:true})
        let datos = [];

        let {usuario} = this.state;

        let listadoCiclos = await ciclo.cicloEstudiante(usuario); 

        if(listadoCiclos.length>0){
        
            for (const i in listadoCiclos) {
                let listado = await anuncio.paraEstudiante(listadoCiclos[i].ciclo_id)
                for (const x in listado) {
                    datos.push(listado[x])
                }
            }
          
            
        }
        this.setState({data: datos, cargando:false, cargandoTabla:false})
    }


    componentDidMount() {
        this.setState({cargando:true})
        this.listadoAnuncios(); 
    }


    render(){
        const {data, cargando, cargandoTabla} = this.state; 

        return (
            <Page title="Ver anuncios" breadcrumbs={[ { name: 'Ver anuncios', active: true } ]}>
                <Cargando valor={cargando} visible={false}/>
                {
                    !cargandoTabla  ? (
                        data.length>0 ? 
                        (
                            <Table bordered striped className="tabla-general tabla2">
                                <thead>
                                    <tr>
                                        <th className="ocultar-en-somen" style={{minWidth:100}}>Profesor</th>
                                        <th className="ocultar-en-somen" style={{minWidth:70}}>Fecha</th>
                                        <th className="ocultar-en-somen">Título</th>
                                        <th className="ocultar-en-somen">Contenido</th>
                                        <th className="ocultar-m-omas">Anuncios</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {data.map(a =>{
                                            return(
                                                <tr key={a.id}>
                                                    <td className="ocultar-en-somen">{a.usuario_nombres} {a.usuario_apellidos}</td>
                                                    <td className="ocultar-en-somen">{a.fecha}</td>
                                                    <td className="ocultar-en-somen">{a.titulo}</td>
                                                    <td className="ocultar-en-somen">{a.contenido}</td>
                                                    <td className="ocultar-m-omas">
                                                        <div>{a.usuario_nombres} {a.usuario_apellidos}</div>
                                                        <div>{a.fecha}</div>
                                                        <div>{a.titulo}</div>
                                                        <div>{a.contenido}</div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
    
                    
                                </tbody>
                            </Table> 
                        ):(<div className="sin-registros">Sin registros</div>)
                    ): (<CargandoTabla />)
                }
                      
            </Page>

          );
    }
 
};

export default VerAnuncios;



